const AxiosCall = (path)=>{
    
    const baseURL = "https://pexer.herokuapp.com/api/v1"  //process.env.SERVER_URL;
    return `${ baseURL}/${ path }`
}
export default AxiosCall;